import { render } from "./TableList.vue?vue&type=template&id=027552d6&ts=true"
import script from "./TableList.vue?vue&type=script&lang=ts"
export * from "./TableList.vue?vue&type=script&lang=ts"

import "./TableList.vue?vue&type=style&index=0&id=027552d6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__